<template>
  <div>
    <van-nav-bar
      :title="selectedUser.user.username"
      left-arrow
      @click-left="$router.push('/chatroom')"
      class="navStyles"
    >
      <!-- <template #right>
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template> -->
    </van-nav-bar>
    <!-- <van-divider>
      <span class="dividerStyle">09-02 12:19</span>
    </van-divider> -->
    <div
      class="chatWindowBody"
      id="windowBody"
      style="padding-top: 45px; padding-bottom: 60px; background: #ffffff"
    >
      <van-list
        v-model="listLoading"
        @load="loadHistory"
        :finished="systemFinished"
      >
        <!-- ================================== Left message window (AGENT) ============================================ -->
        <van-row
          class="rowDesign"
          v-for="(m, index) in message_list"
          :key="index"
        >
          <ul v-if="m.action !== '888'">
            <li>
              <!-- v-for="message in selectedMessageList" :key="message.id" -->
              <div v-bind:class="[m.sender === account ? 'receive' : 'sent']">
                <!-- v-bind:class="[
                message.sender === selectedUser.id ? 'receive' : 'sent',
              ]" -->
                <van-col span="3" v-if="m.sender === account">
                  <img
                    src="../assets/images/login_logo.png"
                    class="imageleft"
                  />
                </van-col>
                <!-- <van-row
                  ><span style="color: #646566; font-size: 14px"
                    >Agent1</span
                  ></van-row
                > -->
                <van-col span="21">
                  <div
                    v-bind:class="[
                      m.sender === account
                        ? 'messageStyle'
                        : 'messageStyleSent',
                    ]"
                  >
                    <div
                      v-bind:class="[
                        m.sender === account
                          ? 'talk_bubble round tri_right left_top'
                          : 'talk_bubble round tri_right right_in',
                      ]"
                    >
                      <!-- v-bind:class="[
                    message.sender === selectedUser.id
                      ? 'talk_bubble round tri_right left_top'
                      : 'talk_bubble round tri_right right_in',
                  ]" -->
                      <!-- ========================= Text ======================= -->
                      <p
                        v-if="m.format == 0"
                        style="font-size: 13px"
                        v-html="processContent(m.content)"
                      ></p>
                      <!-- ============================== Image ============================= -->

                      <img
                        v-if="m.format == 1"
                        v-bind:src="
                          chatUrl +
                          '/files/chat-space/' +
                          JSON.parse(m.content).image
                        "
                        style="width: 100%"
                        @click="
                          showImage(
                            chatUrl +
                              '/files/chat-space/' +
                              JSON.parse(m.content).image
                          )
                        "
                      />
                      <van-image-preview
                        v-model="show"
                        :images="images"
                        :maxZoom="10"
                        :showIndex="false"
                      >
                      </van-image-preview>

                      <!-- ================================= Video ========================= -->

                      <video v-if="m.format == 8" controls style="width: 100%">
                        <source
                          v-bind:src="
                            chatUrl +
                            '/files/chat-space/' +
                            JSON.parse(m.content).video
                          "
                          type="video/mp4"
                        />
                      </video>

                      <!-- ================================= File - pdf ========================= -->
                      <!-- def.png == doc.png == gif.png == html.png == jpeg.png == mp3.png == png.png == ppt.png == rar.png == txt.png  == xls.png == zip.png -->

                      <img
                        v-if="m.format == 3"
                        :src="fileType(m.content)"
                        @click="onFile(m.content)"
                        style="width: 90px; display: block"
                      />

                      <!-- ============================ DateTime =========================== -->

                      <p style="float: right; color: #646566; font-size: 13px">
                        {{ getTime(m.timestamp) }}
                      </p>
                    </div>
                  </div>
                </van-col>
                <!-- ======================== show right side profile picture (sender image) ============= -->
                <van-col span="3" v-if="m.sender !== account">
                  <img
                    src="../assets/images/login_logo.png"
                    class="imageright"
                  />
                </van-col>
              </div>
            </li>
          </ul>
        </van-row>
      </van-list>
      <!-- ================================== Right message window (User) ============================================ -->
      <!-- <van-row class="rowDesign User">
        <van-col span="20" class="userStyle">
          <van-row class="userRowStyleSender"
            ><span style="color: #646566; font-size: 14px; text-align: right"
              >Agent2</span
            ></van-row
          >
          <van-row class="messageStyleSender">
            <div
              class="talk_bubble round tri_right right_in"
              style="margin-right: 16px"
            >
              <div class="talktext"> -->
      <!-- ========================= Text with Emoji ======================= -->
      <!-- <p v-if="true" style="font-size: 13px">
                  这里是 大牛证券
                  <img
                    src="https://chatapp.hk9999z.com/resource/layim/images/face/11.png"
                  />
                </p> -->
      <!-- ============================== Image ============================= -->

      <!-- <img
                  v-if="false"
                  src="../assets/images/login_logo.png"
                  style="width: 100%"
                />

                <van-image-preview
                  v-model="show"
                  :images="images"
                  :maxZoom="10"
                  :showIndex="false"
                >
                </van-image-preview> -->

      <!-- ============================ DateTime =========================== -->

      <!-- <p style="float: right; color: #646566; font-size: 13px">
                  2021/09/02 01:30 AM
                </p>
              </div>
            </div></van-row
          >
        </van-col>
        <van-col span="4">
          <img src="../assets/images/login_logo.png" class="imageStyle" />
        </van-col>
      </van-row> -->

      <!-- ================================ message box and icon list =============================== -->
      <van-row class="messageBox" v-if="account !== 'system'">
        <van-row style="padding: 4px 10px">
          <van-field
            v-model="message"
            type="textarea"
            placeholder="请输入信息"
            rows="1"
            autosize
            style="
              padding: 10px;
              border: 1px solid #969799;
              max-height: 70px;
              overflow-y: scroll;
              border-radius: 8px;
            "
          />
        </van-row>
        <van-row style="text-align: left; padding: 4px 0px">
          <van-col span="3">
            <van-popover
              v-model="showPopoverEmoji"
              placement="top-start"
              trigger="click"
            >
              <ul style="width: auto">
                <li
                  v-for="(item, index) in emojiIcons"
                  :key="index"
                  @click="showPopoverEmoji = false"
                  style="padding: 5px; float: left"
                >
                  <van-image @click="onEmoj(item)" :src="item.text" />
                </li>
              </ul>

              <template #reference>
                <van-icon
                  name="smile-o"
                  size="30"
                  color="#646566"
                  style="padding-left: 10px"
                />
              </template>
            </van-popover>
          </van-col>
          <van-col span="3">
            <van-uploader :after-read="uploadImage">
              <van-icon
                name="photo-o"
                size="30"
                color="#646566"
                style="padding-left: 10px"
              />
            </van-uploader>
          </van-col>
          <van-col span="3">
            <van-uploader :after-read="fileUpload" accept="*">
              <van-icon
                name="debit-pay"
                size="30"
                color="#646566"
                style="padding-left: 10px"
              />
            </van-uploader>
          </van-col>
          <van-col span="3">
            <van-uploader :after-read="uploadVideo" accept="video/*">
              <van-icon
                name="video-o"
                size="30"
                color="#646566"
                style="padding-left: 10px"
              />
            </van-uploader>
          </van-col>
          <van-col span="12" style="text-align: right; padding-right: 10px">
            <van-button
              @click="sendMessage(0)"
              icon="share"
              color="#646566"
              style="height: 28px"
            >
              发送
            </van-button>
          </van-col>
        </van-row>
      </van-row>

      <!-- ==================================== Emoji List ======================================== -->
      <!-- <van-grid :border="false" :column-num="3">
        <van-grid-item>
          <van-image src="https://img01.yzcdn.cn/vant/apple-1.jpg" />
        </van-grid-item>
        <van-grid-item>
          <van-image src="https://img01.yzcdn.cn/vant/apple-2.jpg" />
        </van-grid-item>
        <van-grid-item>
          <van-image src="https://img01.yzcdn.cn/vant/apple-3.jpg" />
        </van-grid-item>
      </van-grid> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import eventBus from "../assets/js/eventBus";
import Vue from "vue";
import { Toast } from "vant";
import { Browser } from "@capacitor/browser";
Vue.use(Toast);
export default {
  name: "ChatRoomUser",
  data() {
    return {
      chatUrl: process.env.WONDER_CHAT_ROOT,
      account: null,
      selectedUser: {
        user: { username: "" },
      },
      message_list: [],
      message: "",
      show: false,
      images: [require("@/assets/images/login_logo.png")],
      showPopoverEmoji: false,
      emojiIcons: [
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/0.png",
          key: "[微笑]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/1.png",
          key: "[爱你]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/2.png",
          key: "[拜拜]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/3.png",
          key: "[悲伤]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/4.png",
          key: "[鄙视]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/5.png",
          key: "[闭嘴]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/6.png",
          key: "[馋嘴]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/7.png",
          key: "[吃惊]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/8.png",
          key: "[鼓掌]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/9.png",
          key: "[哈哈]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/10.png",
          key: "[害羞]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/11.png",
          key: "[黑线]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/12.png",
          key: "[可爱]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/13.png",
          key: "[可怜]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/14.png",
          key: "[亲亲]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/15.png",
          key: "[生病]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/16.png",
          key: "[偷笑]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/17.png",
          key: "[挖鼻]",
        },
        {
          text:
            process.env.WONDER_CHAT_ROOT + "/resource/layim/images/face/18.png",
          key: "[委屈]",
        },
      ],
      listLoading: false,
      systemPage: 0,
      systemFinished: false,
      qserver_url:""
    };
  },
  methods: {
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url});
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    showImage(image) {
      this.images = [image];
      this.show = true;
    },
    loadMessageList() {
      if (this.account !== "system") {
        this.selectedUser = this.$store.state.message_list.find(
          (o) => o.id == this.account
        );
        if (this.selectedUser !== null) {
          this.message_list = this.selectedUser.messages;
        }
      } else {
        this.message_list = this.$store.state.system_messages;
      }

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 500);
      this.readUnreadMessages();
    },
    loadMessageHistory() {
      let that = this;
      that.listLoading = true;
      let lastMessageId =
        that.message_list.length > 0
          ? that.message_list[that.message_list.length - 1].id
          : 0;
      that
        .$wonderChat({
          url:
            "api/message/getMessageHistory/" +
            lastMessageId +
            "/" +
            that.account,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          that.listLoading = false;
          let data = res.data;
          if (data.data.length > 0) {
            that.$store.commit("addMessageToHistory", {
              account: that.account,
              data: data.data,
            });
          }
          that.systemFinished = true;
          if (that.account === "system")
            that.$store.commit("readSystemMessages");
          setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
          }, 1000);
          // data.data.DataList.forEach((element) => {
          //   that.message_list.push(element);
          // });
          // that.$store.commit("readSystemMessages");
          // that.systemPage++;
          // if (that.systemPage >= data.data.page.countPage) {
          //   that.systemFinished = true;
          //   return;
          // }
          // if (data.data.page.count <= data.data.page.size) {
          //   that.systemFinished = true;
          //   return;
          // }
        });
    },
    loadHistory() {
      let that = this;
      if (that.account !== "system" && that.message_list.length > 0) {
        that.listLoading = false;
      } else {
        this.loadMessageHistory();
      }
    },
    // loadSystemMessage() {
    //   let that = this;
    //   that.listLoading = true;
    //   that
    //     .$wonderChat({
    //       url:
    //         "api/message/getMessageHistory/" +
    //         lastMessageId +
    //         "/" +
    //         that.account,
    //       method: "post",
    //       headers: {
    //         "access-token": that.$store.state.wonder_chat_token,
    //       },
    //       data: {},
    //     })
    //     .then((res) => {
    //       that.listLoading = false;
    //       let data = res.data;
    //       data.data.DataList.forEach((element) => {
    //         that.message_list.push(element);
    //       });
    //       that.$store.commit("readSystemMessages");
    //       that.systemPage++;
    //       if (that.systemPage >= data.data.page.countPage) {
    //         that.systemFinished = true;
    //         return;
    //       }
    //       if (data.data.page.count <= data.data.page.size) {
    //         that.systemFinished = true;
    //         return;
    //       }
    //     });
    // },
    readUnreadMessages() {
      // this.message_list.forEach((e) => {
      //   if (!e.read) {
      //     this.readRequest(e.id, this.account, e);
      //   }
      // });
      this.$store.commit("readAllUnread", {
        account: this.account,
        context: this,
      });
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 1000);
    },
    readRequest(id, account) {
      let that = this;
      that
        .$wonderChat({
          url: "api/message/read/" + id + "/" + account,
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {});
    },
    uploadImage(file) {
      this.uploadFile(file, 3);
    },
    uploadVideo(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.uploadApiFile(formData, 8);
    },
    fileUpload(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.uploadApiFile(formData, 3);
    },
    uploadApiFile(formData, format) {
      let that = this;
      Toast.loading();
      that
        .$wonderChat({
          url: "/api/file/file",
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            Toast.clear();
            switch (format) {
              case 8:
                var content = {
                  duration: 2,
                  image: "73859a7c9b404f16b4c818b0d2983a9c.jpg",
                  mode: 1,
                  size: "5",
                  video: data.data.file,
                };
                that.sendMessage(8, content);
                break;
              case 3:
                var content = {
                  file: data.data.file,
                  name: data.data.original,
                  size: "24280",
                };
                that.sendMessage(3, content);
                break;
              default:
                break;
            }
          } else {
            Toast.clear();
          }
        });
    },
    uploadFile(file, format) {
      let that = this;
      let formData = new FormData();
      formData.append("file", file.file);
      Toast.loading();
      that
        .$wonderChat({
          url: "/web/file",
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            Toast.clear();
            that.sendMessage(1, data.data);
          } else {
            Toast.clear();
          }
        });
    },
    sendMessage(format = 0, content) {
      switch (format) {
        case 0:
          content = this.message;
          this.sendMessageApi(content, format, this.account);
          break;
        case 1:
          this.sendMessageApi(JSON.stringify(content), format, this.account);
          break;
        case 8:
          this.sendMessageApi(JSON.stringify(content), format, this.account);
          break;
        case 3:
          this.sendMessageApi(JSON.stringify(content), format, this.account);
          break;
        default:
          break;
      }
      this.message = "";
    },
    sendMessageApi(content, format, receiver) {
      let that = this;
      let sender = localStorage.getItem("user_number");
      if (!sender) {
      that.$toast.fail("发送人无效，请重新登录");
      return;
      }
      let data = {
        content: content,
        action: 0,
        sender: sender,
        receiver: receiver,
        format: format,
      };

      that
        .$wonderChat({
          url: "/api/message/send",
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: data,
        })
        .then((res) => {
          if (res.data.code == 200) {
            data.timestamp = res.data.timestamp;
            data.id = res.data.id.toString();
            data.read = true;

            that.$store.commit("setMessage", {
              message: data,
              caller: that,
              sentMessage: true,
            });

            // $(".chatWindowBody").animate(
            //   { scrollTop: $(".rowDesign").height() },
            //   "fast"
            // );
            setTimeout(() => {
              window.scrollTo(0, document.body.scrollHeight);
            }, 1000);
          }
        })
        .catch((err) => {
          that.$toast.fail("信息发送错误，请重试");
        });
    },
    getTime(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD HH:mm");
    },
    fileType(content) {
      let fileNameArray = JSON.parse(content).name.split(".");
      let fileType = fileNameArray[fileNameArray.length - 1];
      switch (fileType) {
        case "pdf":
          return require("../assets/images/chat_files/pdf.png");
          break;
        case "doc":
          return require("../assets/images/chat_files/doc.png");
          break;
        case "docx":
          return require("../assets/images/chat_files/doc.png");
          break;
        case "ppt":
          return require("../assets/images/chat_files/ppt.png");
          break;
        case "xls":
          return require("../assets/images/chat_files/xls.png");
          break;
        case "xlsx":
          return require("../assets/images/chat_files/xls.png");
          break;
        case "jpeg":
          return require("../assets/images/chat_files/jpeg.png");
          break;
        case "jpg":
          return require("../assets/images/chat_files/jpeg.png");
          break;
        case "mp3":
          return require("../assets/images/chat_files/mp3.png");
          break;
        case "png":
          return require("../assets/images/chat_files/png.png");
          break;
        case "rar":
          return require("../assets/images/chat_files/rar.png");
          break;
        case "txt":
          return require("../assets/images/chat_files/txt.png");
          break;
        case "zip":
          return require("../assets/images/chat_files/zip.png");
          break;
        case "gif":
          return require("../assets/images/chat_files/gif.png");
          break;

        default:
          return require("../assets/images/chat_files/def.png");
          break;
      }
    },
    onEmoj(item) {
      console.log(item);
      this.message += "face" + item.key;
    },
    processContent(content) {
      let that = this;
      content = content.replace(/face\[([^\s\[\]]+?)\]/g, function (face) {
        //转义表情
        var alt = face.replace(/^face/g, "");
        var imgPath = that.emojiIcons.find((o) => alt === o.key);
        return (
          '<img alt="' +
          alt +
          '" title="' +
          alt +
          '" src="' +
          imgPath.text +
          '">'
        );
      });
      return content;
    },
    greetingMessage() {
      let that = this;
      that
        .$wonderChat({
          url: "api/message/greeting",
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: { agent: this.account },
        })
        .then((res) => {
          if (res.data.code == 200) {
          }
        });
    },
    onFile(content) {
      let url = this.chatUrl + "/files/chat-space/" + JSON.parse(content).file;
      window.open(url, "_self");
    },
  },
  computed: {},
  mounted: function () {
    eventBus.$on("readMessage", (data) => {
      this.readUnreadMessages();
    });
    this.account = this.$route.params.account;
    if (this.account == null) {
      alert("invalid account number"); //TODO add proper error message;
      this.$router.go(-1);
      return;
    }
    this.loadMessageList();
    this.greetingMessage();
    this.get_qchat_server_url();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.messageStyle {
  padding-top: 12px;
  text-align: left;
  line-height: 20px;
}

.messageStyleSent {
  padding-top: 12px;
  text-align: right;
  line-height: 20px;
}

.messageStyleSent p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  text-align: justify;
  margin: 0px;
}

.messageStyle p {
  /* remove webkit p margins */
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  text-align: justify;
  margin: 0px;
}

.messageBox {
  position: fixed;
  bottom: 43px;
  left: 0px;
  width: 100%;
  background: #ffffff;
}

.rowDesign {
  padding: 0px 10px;
}

.receive {
  float: unset;
  /* display: inline-flex; */
}

.sent {
  /* display: inline-flex; */
  text-align: right;
}

.imageleft {
  width: 30px;
  border-radius: 50%;
  float: left;
  margin: 6px 8px 0 0;
  height: 30px;
}

.imageright {
  width: 30px;
  border-radius: 50%;
  float: right;
  margin: 6px 0 0 8px;
  height: 30px;
}

.dividerStyle {
  background: #c8c9cc;
  padding: 4px 12px;
  border-radius: 5px;
  color: #000000;
}

.talk_bubble {
  display: inline-block;
  position: relative;
  width: auto;
  height: auto;
  background-color: #dcdee0;
  padding: 12px;
}

.tri_right.border.left_top:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -40px;
  right: auto;
  top: -8px;
  bottom: auto;
  border: 32px solid;
  border-color: #666 transparent transparent transparent;
}
.tri_right.left_top:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -14px;
  right: auto;
  top: 6px;
  bottom: auto;
  border: 14px solid;
  border-color: #dcdee0 transparent transparent transparent;
}

.tri_right.border.right_in:before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -40px;
  top: 30px;
  bottom: auto;
  border: 20px solid;
  border-color: #666 transparent transparent #666;
}
.tri_right.right_in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -16px;
  top: 4px;
  bottom: auto;
  border: 9px solid;
  border-color: #dcdee0 transparent transparent #dcdee0;
}

.round {
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
}

.chatTextDesign {
  border: 1px solid #ffffff;
  color: #ffffff;
  font-size: 12px;
  padding: 0px 12px;
  border-radius: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/ChatRoomUser.vue